import type { IconSvgObject } from './types';

const Facebook01Icon: IconSvgObject = [
  ["path", { d: "M19.5 2.5C20.6046 2.5 21.5 3.39543 21.5 4.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H19.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.0001 7.5H14.0006C12.8931 7.5 11.9965 8.39996 12.0006 9.50742L12.0154 13.4995M12.0154 13.4995V21.5M12.0154 13.4995H10.0001M12.0154 13.4995H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Facebook01Icon;
